import React from "react";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import Mall from '../../../../ASSETS/tourisme/Image/image_loisirs/Mall.png'
import muse from '../../../../ASSETS/tourisme/Image/image_loisirs/Musée_des_civilisations1.png'
import cosmos from '../../../../ASSETS/tourisme/Image/image_loisirs/cosmos.png'
import galerie from '../../../../ASSETS/tourisme/Image/image_loisirs/galerieCecile.png'
import paradisia from '../../../../ASSETS/tourisme/Image/image_loisirs/paradisia.png'
import sofitel from '../../../../ASSETS/tourisme/Image/image_loisirs/sofitel-abidjan-hotel.png'
import "pure-react-carousel/dist/react-carousel.es.css";
import {Link} from 'react-router-dom'
import { useState, useEffect } from 'react';
import Culture from '../../../../API/tourisme/loisir/index'
/* Install pure-react-carousel using -> npm i pure-react-carousel */

export default function Index() {

  const [loisirs, setLoisirs] = useState([]);
  const getAllLoisir = () => {
        Culture.getAllData()
          .then((res) => {
              //console.log('Response:',res.data);

            if (res.data.status === 200) {
              setLoisirs(res.data.data);
            }
          })
          .catch((err) => {
            console.log(err);
          })
      };
  useEffect(() => {
        getAllLoisir();
    
  }, []);
    
  const handleRedirect = (id) => {
    window.location.href = `/Loisirs_Activite/Voir_Plus?id=${id}`;
  };

  return (
    <div className=" mx-auto bg-[#233D4D] mb-20">
      <div className="flex items-center justify-center w-full h-full py-24 sm:py-8 px-4">
        {/* Carousel for desktop and large size devices */}
        <CarouselProvider 
          className="md:block hidden" 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={loisirs.length} 
          visibleSlides={4} 
          step={1} 
          infinite={true}
        >
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700">
                  {loisirs.map((item, index)=>(
                    <Slide index={index} key={index}>
                      <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                        <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                        <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                          <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog {index + 1}</h2>
                          {/* <Link to=""> */}
                            <div onClick={() => handleRedirect(item.id_announce)} className="flex h-full items-end pb-6 cursor-pointer">
                              <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">{item?.title_announce}</h3>
                            </div>
                          {/* </Link> */}
                        </div>
                      </div>
                    </Slide>
                  ))}
                  {/* <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                        <div className="flex h-full items-end pb-6">
                          <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={0}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={Mall} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 1</h2>
                        <Link to="">
                          <div className="flex h-full items-end pb-6 ">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Mall de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                        <div className="flex h-full items-end pb-6">
                          <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  */}
                  
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for tablet and medium size devices */}
        <CarouselProvider 
          className="md:hidden xs:block hidden" 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={loisirs.length} 
          visibleSlides={2} 
          step={1} 
          infinite={true}
        >
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700">
                  {loisirs.map((item, index)=>(
                  <Slide index={index} key={index}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog {index + 1}</h2>
                        {/* <Link to=""> */}
                          <div onClick={() => handleRedirect(item.id_announce)} className="flex h-full items-end pb-6 cursor-pointer">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">{item?.title_announce}</h3>
                          </div>
                        {/* </Link> */}
                      </div>
                    </div>
                  </Slide>
                  )) }
                  {/* <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>

                  <Slide index={0}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={Mall} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 1</h2>
                        <Link to="">
                          <div className="flex h-full items-end pb-6 ">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Mall de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide> */}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for mobile and Small size Devices */}
        <CarouselProvider 
          className="block xs:hidden" 
          naturalSlideWidth={100} 
          isIntrinsicHeight={true} 
          totalSlides={loisirs.length} 
          visibleSlides={1} 
          step={1} 
          infinite={true}
        >
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer" id="prev">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 7L7 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full w-full flex lg:gap-8 md:gap-6 items-center justify-start transition ease-out duration-700">
                  {loisirs.map((item, index)=>(
                    <Slide index={index} key={index}>
                      <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                        <img src={`data:image/png;base64,${item[0]}`} alt={item?.title_announce} className="object-cover object-center w-full" />
                        <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                          <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog {index + 1}</h2>
                          {/* <Link to=""> */}
                            <div onClick={() => handleRedirect(item.id_announce)} className="flex h-full items-end pb-6 cursor-pointer">
                              <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">{item?.title_announce}</h3>
                            </div>
                          {/* </Link> */}
                        </div>
                      </div>
                    </Slide>
                  ))}
                  {/* <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>

                  <Slide index={0}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={Mall} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 1</h2>
                        <Link to="">
                          <div className="flex h-full items-end pb-6 ">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Mall de Yamoussokro</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={1}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={cosmos} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 2</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La cosmos de Man</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={2}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={muse} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 3</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La muse de kouto</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={3}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={galerie} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 4</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La forêt du galerie</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={4}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={paradisia} alt="black chair and white table" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 5</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">La Cathédrale Saint Paul</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                  <Slide index={5}>
                    <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                      <img src={sofitel} alt="sitting area" className="object-cover object-center w-full" />
                      <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                        <h2 className="lg:text-xl leading-4 text-base lg:leading-5 text-white">Catalog 6</h2>
                        <Link>
                          <div className="flex h-full items-end pb-6">
                            <h3 className="text-lg lg:text-2xl font-semibold leading-5 lg:leading-6 text-white">Le sofitel de Dabou</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </Slide>
                   */}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400" id="next">
              <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>

      

    </div>
  );
}
